import { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { fetchBedList, fetchIpd, ipdReg } from './ipdService';
import { fetchWardApiCall } from '../master/ward/watchService';
import { handleValidation } from './validation';
import { errorToast, successToast } from '../../components/toastmessage/toastmessage';

function useIPDHook(initialState) {
    const [ipdState, setIpdState] = useState(initialState);
    const [wardStatList, setWardStatList] = useState([]);
    const [bedStatList, setBedStatList] = useState([]);
    const [ipdList, setIpdList] = useState([]);
    const [errors, setError] = useState({})
    const navigate = useNavigate();
    const location = useLocation();

    const handleIPDRoute = (e,params) => {
        navigate("/register", { state: { rowData: params } })

    }
    const handleAddIPDRoute = (e, params) => {
        navigate("/patient-registration", { state: { rowData: params } })

    }
    const  handleGoBack= () => {
        navigate("/patient-registration")
    }

    const handleAddVoucher = (params) => {
        navigate("/add-voucher", { state: { rowData: params } })
    }
    const handleIPDChange = (e, type, nested) => {
        const { name, value } = e.target;
        if (type) {
            setIpdState((prevFormState) => ({
                ...prevFormState,
                [name]: e.target.checked,
            }));
        } else if (nested) {
            setIpdState((prevFormState) => ({
                ...prevFormState,
                insuranceDetail: {
                    ...ipdState?.insuranceDetail,
                    [name]: value
                },
            }));
        }
        else {
            setIpdState((prevFormState) => ({
                ...prevFormState,
                [name]: value,
            }));

        }

    }
    const deleteObj = (fromState) => {
        if (fromState?.billingMode === "Cash") {
             delete fromState.insuranceDetail
             return fromState;
        } else {
            return fromState;
        }
    }
    const handleBlur = async () => {
        const newErrors = await handleValidation(ipdState);
        let inputError = {
            ...newErrors?.errors,
            formIsValid: newErrors?.formIsValid,
            basicInfoError: newErrors?.individualInputErrors
        };
        setError(inputError)

    };
    const ReArangePayload = (fromState) => {
        const commonProperties = {
         modifiedBy: JSON.parse(sessionStorage.getItem("loginDetails"))?.uniqueID, 
          createdBy: JSON.parse(sessionStorage.getItem("loginDetails"))?.uniqueID, 
          tenantID: JSON.parse(sessionStorage.getItem("tenantDetails"))[0]?.tenantID,
          patientID: location?.state?.rowData?.uniqueID,
          activeStatus: true,
          dischargeStatus: 0,
          billingMode: fromState?.billingMode === "Insurance" ? 0 : 1,

        };
      
        if (fromState?.billingMode === "Insurance") {
          return {
            ...fromState,
            ...commonProperties,
            insuranceDetail: {
              ...fromState.insuranceDetail,
              amount: Number(fromState?.insuranceDetail?.amount),
            },
          };
        } else {
          return {
            ...fromState,
            ...commonProperties,
          };
        }
      };

    const handleIPD = async (e, fromState) => {
        e.preventDefault();
        let obj = await deleteObj(fromState)
        const payload = await ReArangePayload(obj);
        let isValid = await handleValidation(payload);
        if (isValid?.isValid) {
            try {
                await ipdReg(payload);
                successToast("Successfully Inserted");
                setIpdState(initialState)
            } catch (err) {
                errorToast(err?.response?.data?.message)
            }

        } else {
            setError(isValid?.errors)
        }


    }
    const fetchIPDList = useCallback(async () => {
        try {
            const response = await fetchIpd();
            if(response?.status === 200) setIpdList(response?.data?.result)
        } catch (e) {
            console.error(e)
        }
    }, [])

    const fetchWards = async () => {
        try {
            let result = await fetchWardApiCall();
            if (result.status === 200) setWardStatList(result?.data?.result)
        } catch (e) {
            return e;
        }

    }
    // fetchBedList
    const fetchBeds = async () => {
        try {
            let result = await fetchBedList();
            if (result.status === 200) setBedStatList(result?.data?.result)
        } catch (e) {
            return e;
        }

    }

    const allowNumbersOnly = (e) => {
        var code = (e.which) ? e.which : e.keyCode;
        if (code > 31 && (code < 48 || code > 57)) {
            e.preventDefault();
        }
    }

    useEffect(() => {
        fetchIPDList();
        fetchWards();
        fetchBeds();
    }, [])

    const handleGetRowId = (e) => {
        return e?.ipdid
    }
    return {
        setIpdState,
        fetchIPDList,
        handleIPD,
        handleIPDRoute,
        handleIPDChange,
        ipdState,
        wardStatList,
        bedStatList,
        allowNumbersOnly,
        errors,
        handleBlur,
        ipdList,
        handleGetRowId,
        handleAddVoucher,
        handleAddIPDRoute,
        handleGoBack


    };
}

export default useIPDHook;






  